import { api } from "./api";

export const attendanceBatchStudentsPost = async (data) => {
  return await api.post(`/students/attendances/post`, data);
};


// -------------------------------------------------------

// ✅ Updated API function to accept both batch_id and date
export const studentsAttendance = async (addUrl = "") => {
  let url = `/student/attendance/list?${addUrl}`;
  return await api.get(url);
};

export const DemoStudentList = async (addUrl = "") => {
  let url = `/demo/attendance/list?${addUrl}`;
  return await api.get(url);
};

export const StaffList = async (addUrl = "") => {
  return await api.get(`staff/v2/list?${addUrl}`);
};

export const StudentBatchList = async (data) => {
  return await api.get(`batches`, data);
};

export const AllDemoPrasentBatch = async (addUrl = "") => {
  let url = `/demo/attendance/batch?${addUrl}`;
  return await api.post(url);
};

export const SinglePresent = async ({ registration_no, date, attendance }) => {
  return await api.post(
    `attendance/soft/update?registration_no=${registration_no}&date=${date}&attendance=${attendance}`
  );
};

export const DemoSinglePresent = async (payload) => {
  return await api.post(`/single/demo/attendance`, payload);
};

export const BioData = async (addUrl = "") => {
  let url = `/biometric/log/list?${addUrl}`;
  return await api.get(url);
};

export const BioDevicelist = async (addUrl = "") => {
  return await api.get(`biometric/device/list?${addUrl}`);
};

export const BioDevice = async (payload) => {
  return await api.post(`biometric/device/add`, payload);
};
export const BioDeviceDelete = async (payload) => {
  console.log("hfadsbfds", payload);
  return await api.post(`/biometric/device/delete`, payload);
};
export const BioDeviceStatus = async (payload) => {
  return await api.post(`biometric/device/status`, payload);
};
